import React, {Component} from 'react'

import PaperBlock from "../../ui/PaperBlock"
import TextField from '@material-ui/core/TextField'

/**
 * <SearchPanel onChange = {searchString} />
 */

class SearchPanel extends Component {

	state = {
		searchString: ""
	}

	render() {

		return <PaperBlock
			style = {{display: "flex"}}
			onClick = {e => {
				e.stopPropagation()
			}}
		>

			<TextField
				style = {{flex: "1 1 auto"}}
				label = "Поиск по названию"
				value = {this.state.searchString}
				onChange={e => {
					this.setState({
						searchString: e.target.value
					}, () => {
						if (typeof this.props.onChange === "function") {
							this.props.onChange(this.state.searchString)
						}
					})
				}}
			/>

		</PaperBlock>

	}

}

export default SearchPanel
